import React from 'react';
import playStore from "../dist/images/play_store.svg";
import appStore from "../dist/images/app_store.svg";
import webStore from "../dist/images/webStore.svg";

const appLinks = [
  { logo: playStore, driverLink: "https://play.google.com/store/apps/details?id=com.instadriver.app", partnerLink:'https://play.google.com/store/apps/details?id=com.instadriver.partner.app' },
  { logo: appStore, driverLink: "", partnerLink:'' },
  { logo: webStore, driverLink: "https://instadriver.co/register?type=driver", partnerLink:'https://instadriver.co/register-account?type=gig-partner' },
]
export default function AppLinksSection({isDriver}) {
  return (
    <div className="d-flex flex-wrap gap-2 gap-md-5 align-items-center justify-content-center">
      {appLinks.map((appLink, index) => (
        <a
          key={index}
          rel="noreferrer"
          target="_blank"
          href={isDriver ? appLink.driverLink : appLink.partnerLink}
        >
          <img src={appLink.logo} alt="app-store" width="165" />
        </a>
      ))}
    </div>
  )
}
